import moment from 'moment'
import Vue from 'vue'

Vue.filter('livraison', function(value: number) {
  if (value || value === 0) {
    switch(value)    {
      case 0:
      case 1:{
        return "Domicile :"
      }
      case 2:{
        return "Point relais :"
      }
      case 3:{
        return "Retrait magasin :"
      }
    }
  }
  return ""
})